<!-- #region cookie note template -->
<!-- #endregion -->

<!-- #region note of thanks template -->
<!-- #endregion -->

<section>
    <div class="content-container clearfix p:24 md:p-32 lg:p-48">
        <div class="grid-container p-24:b md:p-32:b lg:p-48:b -center-v">
            <div class="g-8">
                <h3>Wir bedanken uns für Dein Vertrauen - Dein Antrag wurde erfolgreich eingereicht.</h3>
            </div>
            <div class="g-4">
                <svg
                    class="checksvg"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 110 110"
                >
                    <path
                        class="checkmark"
                        fill="none"
                        stroke-width="8"
                        stroke-miterlimit="10"
                        d="M87.99,23.12c-8.32-8.63-20-14.01-32.99-14.01C29.72,9.11,9.11,29.72,9.11,55s20.61,45.89,45.89,45.89,45.89-20.61,45.89-45.89c0-8.73-2.44-16.85-6.6-23.76h0l-42.94,43.05-21.22-21.22"
                    />
                </svg>
            </div>
            <div class="g-12">
                <hr />
            </div>
        </div>
        <p>
            Du erhältst in Kürze von uns per E-Mail deinen Versicherungsschein und deine persönlichen Zugangsdaten zum
            Online-Portal.
        </p>
        <p class="m-24:t md:m-32:t lg:m-48:t">Viele Grüße aus Mannheim<br />Deine astra Versicherung AG</p>
    </div>
</section>
@if (showForm) {
    @if (!formSubmitted) {
        <section class="bg:grey-5 p-24:b m-24:b md:m-32:b lg:m-48:b md:p-24:b">
            <div class="content-container">
                <div class="p-24:t md:p-32:t">
                    <h2 class="c:blue-700">Woher kennst du uns?</h2>
                    <form
                        [formGroup]="form"
                        (submit)="submit()"
                    >
                        <input
                            type="radio"
                            id="radio-check24"
                            value="check24"
                            formControlName="whereDoYouKnowUsFrom"
                        />
                        <label for="radio-check24">Check24</label>
                        <input
                            type="radio"
                            id="radio-google"
                            value="google"
                            formControlName="whereDoYouKnowUsFrom"
                        />
                        <label for="radio-google">Google</label>
                        <input
                            type="radio"
                            id="radio-locker"
                            value="locker"
                            formControlName="whereDoYouKnowUsFrom"
                        />
                        <label for="radio-locker">Schließfach / Schule</label>
                        <input
                            type="radio"
                            id="radio-social"
                            value="social"
                            formControlName="whereDoYouKnowUsFrom"
                        />
                        <label for="radio-social">Social-Media</label>
                        <input
                            type="radio"
                            id="radio-recommendation"
                            value="recommendation"
                            formControlName="whereDoYouKnowUsFrom"
                        />
                        <label for="radio-recommendation">Empfehlung (Freunde, Familie, Bekannte)</label>
                        <input
                            type="radio"
                            id="radio-verivox"
                            value="verivox"
                            formControlName="whereDoYouKnowUsFrom"
                        />
                        <label for="radio-verivox">Verivox</label>
                        <input
                            type="radio"
                            id="radio-other"
                            value="other"
                            formControlName="whereDoYouKnowUsFrom"
                        />
                        <label for="radio-other">Andere (Bitte angeben)</label>
                        @if (form.get('other').enabled) {
                            <input
                                type="text"
                                id="input-other"
                                placeholder="Woher kennst du uns?"
                                formControlName="other"
                                aria-label="Woher kennst du uns?"
                            />
                        }
                        <div class="grid-container">
                            <div class="g-12 xs:g-6 md:g-3 m-6:b">
                                <button
                                    type="submit"
                                    [disabled]="form.invalid"
                                >
                                    Abschicken
                                </button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </section>
    } @else {
        <section class="m-24:b md:m-32:b lg:m-48:b md:p-24:b thankYouMessage">
            <div class="content-container p-24:t md:p-32:t">
                <div class="grid-container">
                    <div class="g-12">
                        <p class="c:white"><strong>Danke fürs Mitmachen!</strong></p>
                    </div>
                </div>
            </div>
        </section>
    }
} @else {
    <section class="bg:grey-5 p-24:b m-24:b md:m-32:b lg:m-48:b md:p-24:b">
        <div class="content-container p-24:t md:p-32:t">
            <div class="grid-container">
                <div class="g-12">
                    <p>
                        <strong
                            >Hoppla, leider kannst du an unserer Umfrage nicht teilnehmen, weil du den analytischen
                            Cookies nicht zugestimmt hast. Bitte akzeptiere sie noch schnell und hilf uns mit deiner
                            Stimme.</strong
                        >
                    </p>
                </div>
                <div class="g-12 xs:g-6 sm:g-3 m-6:b xs:m-0:b">
                    <button
                        type="button"
                        class="button"
                        (click)="openCookieDialog()"
                    >
                        Cookie-Einstellungen
                    </button>
                </div>
            </div>
        </div>
    </section>
}
<section class="content-container m-96:b">
    <div class="grid-container p-24:b md:p-32:b lg:p-48:b -center-content">
        <div class="g-12 align:center">
            <h3><strong>Über unsere Social-Media-Kanäle kannst du mit uns in Kontakt bleiben.</strong></h3>
        </div>
        <div class="g-auto">
            <a
                href="https://www.instagram.com/astraversicherung/"
                target="_blank"
                aria-label="Astra Versicherungen - Instagram-Seite"
                rel="noopener"
            >
                <svg
                    baseProfile="tiny"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 36 36"
                    width="50"
                    height="50"
                    overflow="visible"
                    xml:space="preserve"
                    aria-label="Instagram-Logo"
                >
                    <g fill="#606060">
                        <path
                            d="M32 0H4C1.8 0 0 1.8 0 4v28c0 2.2 1.8 4 4 4h28c2.2 0 4-1.8 4-4V4c0-2.2-1.8-4-4-4zm.5 23.5c0 5-4.1 9-9 9h-11c-5 0-9-4.1-9-9v-11c0-5 4.1-9 9-9h10.9c5 0 9 4.1 9 9v11z"
                        />
                        <path
                            d="M23.5 6.3h-11c-3.5 0-6.3 2.8-6.3 6.3v10.9c0 3.5 2.8 6.3 6.3 6.3h10.9c3.5 0 6.3-2.8 6.3-6.3v-11c0-3.4-2.8-6.2-6.2-6.2zm-5.5 19c-4 0-7.3-3.3-7.3-7.3s3.3-7.3 7.3-7.3 7.3 3.3 7.3 7.3-3.3 7.3-7.3 7.3zm7.8-14.1c-.5 0-1-.4-1-1 0-.5.4-1 1-1 .5 0 1 .4 1 1 0 .5-.5 1-1 1z"
                        />
                        <circle
                            transform="rotate(-45.001 17.995 17.98)"
                            cx="18"
                            cy="18"
                            r="4.5"
                        />
                    </g>
                </svg>
            </a>
        </div>
        <div class="g-auto">
            <a
                href="https://www.tiktok.com/@astraversicherung"
                target="_blank"
                rel="noopener"
                aria-label="Astra Versicherungen - TikTok-Seite"
            >
                <svg
                    baseProfile="tiny"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 36 36"
                    width="50"
                    height="50"
                    overflow="visible"
                    xml:space="preserve"
                    aria-label="TikTok-Logo"
                >
                    <path
                        fill="#606060"
                        d="M32 0H4C1.8 0 0 1.8 0 4v28c0 2.2 1.8 4 4 4h28c2.2 0 4-1.8 4-4V4c0-2.2-1.8-4-4-4zm-3.3 15.8s-1.5-.1-2.6-.4c-1.5-.4-2.5-1-2.5-1l-.7-.5v8.7c0 .5-.1 1.7-.5 2.7-.3.9-.8 1.7-1.4 2.4 0 0-.9 1.2-2.6 2-1.5.7-2.8.7-3.2.7 0 0-2.3.1-4.3-1.3-.7-.5-1.3-1.1-1.8-1.7-.6-.8-1-1.8-1.2-2.1-.2-.5-.5-1.7-.5-2.8.1-2 .8-3.3.9-3.6.5-.8 1.1-1.6 1.8-2.2 1.7-1.4 3.9-2.1 6.1-1.8v4.3c-.4-.2-.8-.3-1.2-.2-2 0-3.6 1.6-3.6 3.6s1.6 3.6 3.6 3.6c.6 0 1.2-.2 1.8-.5 1-.6 1.7-1.7 1.8-2.9V5.7h4.2s-.1.4.1 1c.1.8.5 1.8 1.4 2.9.4.4.8.8 1.2 1.1.2.1.3.2.5.3 1.1.5 2.1.7 2.7.6v4.2z"
                    />
                </svg>
            </a>
        </div>
        <div class="g-12 p-24:t md:p-32:t align:center">
            <p>
                Wir geben dir persönliche Einblicke hinter die Kulissen der astra und viele Tipps rund um deine
                Versicherung.
            </p>
        </div>
    </div>
</section>
